import React from "react";
import { FileText, Search, Shield, Bell } from "lucide-react";

const TrademarkOverview = () => {
  const overviewPoints = [
    {
      icon: <Search />,
      title: "Comprehensive Trademark Search",
      description: "We conduct thorough searches of the USPTO database to identify potential conflicts and ensure your trademark has the best chance of approval. Our search includes federal, state, and common law trademark databases.",
    },
    {
      icon: <FileText />,
      title: "Expert Filing & Documentation",
      description: "Our experienced team handles all the complex paperwork and filing requirements. We prepare and submit your application to the USPTO with precision, ensuring all documentation meets federal standards and regulations.",
    },
    {
      icon: <Shield />,
      title: "Brand Protection Strategy",
      description: "Beyond just filing, we develop a comprehensive brand protection strategy for your business. This includes selecting the right trademark classes, advising on trademark use, and ensuring your brand is properly protected in all relevant categories.",
    },
    {
      icon: <Bell />,
      title: "Ongoing Monitoring & Support",
      description: "After registration, we provide continuous monitoring services to watch for potential infringements. We also handle maintenance filings, renewals, and can assist with enforcement actions to protect your valuable brand assets.",
    },
  ];

  return (
    <section id="trademark-overview" className="trademark-overview-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Understanding Trademark Registration</h2>
          <p className="section-subtitle">
            What Makes Our Trademark Services Comprehensive
          </p>
        </div>

        <div className="overview-intro-card">
          <h3 className="overview-heading">Why Trademark Registration Matters</h3>
          <p className="overview-text">
            A trademark is more than just a logo or business name - it's the foundation of your brand identity and a valuable business asset. Registering your trademark with the USPTO provides federal legal protection, giving you exclusive rights to use your mark in connection with your goods or services across the entire United States.
          </p>
          <p className="overview-text">
            Without proper trademark registration, your brand is vulnerable to copycats, infringement, and potential legal disputes. A registered trademark allows you to take legal action against unauthorized use, prevents others from registering similar marks, and significantly increases your brand's value and credibility in the marketplace.
          </p>
        </div>

        <div className="overview-grid">
          {overviewPoints.map((point, index) => (
            <div key={index} className="overview-card">
              <div className="overview-icon">{point.icon}</div>
              <h4 className="overview-card-title">{point.title}</h4>
              <p className="overview-card-description">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrademarkOverview;
